import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ArrowsUpDownIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/arrows-up-down"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M2.68762 8.15954C3.05186 8.49776 3.62132 8.47667 3.95954 8.11243L6.30003 5.59191L6.30003 15.9C6.30003 16.3971 6.70297 16.8 7.20003 16.8C7.69708 16.8 8.10003 16.3971 8.10003 15.9V5.59191L10.4405 8.11243C10.7787 8.47667 11.3482 8.49776 11.7124 8.15954C12.0767 7.82131 12.0978 7.25186 11.7595 6.88762L7.85954 2.68762C7.68925 2.50423 7.45029 2.40002 7.20003 2.40002C6.94977 2.40002 6.71081 2.50423 6.54051 2.68762L2.64051 6.88762C2.30229 7.25186 2.32338 7.82132 2.68762 8.15954ZM12.2876 15.8405C11.9234 16.1787 11.9023 16.7482 12.2405 17.1124L16.1405 21.3124C16.3108 21.4958 16.5498 21.6 16.8 21.6C17.0503 21.6 17.2893 21.4958 17.4595 21.3124L21.3595 17.1124C21.6978 16.7482 21.6767 16.1787 21.3124 15.8405C20.9482 15.5023 20.3787 15.5234 20.0405 15.8876L17.7 18.4081V8.10002C17.7 7.60297 17.2971 7.20002 16.8 7.20002C16.303 7.20002 15.9 7.60297 15.9 8.10002V18.4081L13.5595 15.8876C13.2213 15.5234 12.6519 15.5023 12.2876 15.8405Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowsUpDownIcon;